<template>
  <mock-up-main>
    <div class="robika-device-container">
      <!-- ۱. مودال نمایش QR Code روبیکا -->
      <channel-qr-modal
        v-model="showQrDialog"
        :title="value.organizationName || value.visitName || 'کانال رسمی روبیکا'"
        :channel-id="cleanrobikaId || 'rubika_id'"
        :profile-avatar="profileAvatar"
        primary-color="#e52d8c"
        :svg-data="qrSvgDataUrl"
        :share-link="address"
      />

      <v-card
        light
        flat
        class="overflow-y-auto robika-preview-wrapper"
        max-height="660"
        :style="containerStyle"
      >
        <!-- ۲. بخش هدر کارت -->
        <div class="robika-header-section" :style="headerStyle">
          <!-- دکمه شناور نمایش QR Code -->
          <v-btn
            fab
            x-small
            elevation="4"
            class="qr-floating-btn"
            title="مشاهده و اسکن QR کد"
            @click="showQrDialog = true"
          >
            <v-icon size="18">mdi-qrcode-scan</v-icon>
          </v-btn>

          <!-- بافت یا تصویر پس‌زمینه هدر -->
          <div
            v-if="bgImageUrl"
            class="header-bg-texture"
            :style="{ backgroundImage: `url(${bgImageUrl})` }"
          ></div>
          <div class="header-gradient-layer"></div>
        </div>

        <!-- ۳. محتوای کارت و پروفایل -->
        <div class="content-container px-4 pb-4 d-flex flex-column align-center text-center">
          <!-- تصویر پروفایل با نشان رسمی روبیکا -->
          <div class="avatar-wrapper mb-3">
            <v-avatar size="92" class="robika-avatar elevation-6">
              <img
                :src="profileAvatar"
                alt="Robika Profile"
                style="object-fit: cover;"
                @error="$event.target.src = defaultrobikaLogo"
              />
            </v-avatar>
            <div class="robika-badge elevation-2" title="پیام‌رسان روبیکا">
              <img
                :src="defaultrobikaLogo"
                alt="Robika Icon"
                class="badge-icon-img"
              />
            </div>
          </div>

          <!-- عنوان کانال یا نام صفحه -->
          <h2
            class="font-weight-black text-h6 mb-1 text-truncate-2 title-glow"
            :style="{ color: textColor }"
          >
            {{ value.organizationName || value.visitName || 'کانال رسمی روبیکا' }}
          </h2>

          <!-- زیرعنوان -->
          <p
            v-if="value.subtitle"
            class="robika-subtitle text-caption font-weight-medium mb-2"
            :style="{ color: textColor, opacity: 0.85 }"
          >
            {{ value.subtitle }}
          </p>

          <!-- قرص شناسه روبیکا (@username) -->
          <div class="robika-id-pill px-3 py-1 mb-3">
            <span class="id-text">@{{ cleanrobikaId || 'rubika_id' }}</span>
            <v-icon x-small color="#e52d8c" class="mr-1">mdi-link-variant</v-icon>
          </div>

          <!-- متن بیوگرافی یا توضیحات -->
          <div class="bio-glass-card pa-3 mb-5 w-100">
            <p
              class="robika-bio text-body-2 mb-0"
              :style="{ color: textColor }"
            >
              {{ value.aboutUs || 'جهت دسترسی سریع، مشاهده جدیدترین محتواها و عضویت در کانال رسمی، یکی از گزینه‌های زیر را انتخاب نمایید.' }}
            </p>
          </div>
          <!-- ۴. دکمه‌های اقدام (Action Buttons) -->
          <div class="action-buttons-box w-100 px-2">
            <!-- دکمه ورود به اپلیکیشن روبیکا -->
            <v-btn
              block
              x-large
              rounded
              class="mb-3 robika-app-btn elevation-4"
              :style="appButtonStyle"
              :href="robikaTargetUrl"
              target="_blank"
            >
              <v-icon left size="22" class="ml-2">mdi-cellphone-message</v-icon>
              <span>{{ value.appButtonText || 'ورود به اپلیکیشن روبیکا' }}</span>
              <v-icon right size="18" class="arrow-icon mr-1">mdi-chevron-left</v-icon>
            </v-btn>

            <v-btn
              block
              x-large
              rounded
              class="mb-3 robika-web-btn"
              :href="robikaWebTargetUrl"
              target="_blank"
            >
              <v-icon left size="20" class="ml-2">mdi-open-in-new</v-icon>
              <span>{{ value.webButtonText || 'مشاهده در نسخه وب روبیکا' }}</span>
            </v-btn>

            <v-btn
              text
              rounded
              class="copy-btn py-1"
              :class="{ 'copied-active': isCopied }"
              @click="copyrobikaLink"
            >
              <v-icon x-small class="ml-1">
                {{ isCopied ? 'mdi-check-circle' : 'mdi-content-copy' }}
              </v-icon>
              <span>{{ isCopied ? 'لینک روبیکا کپی شد!' : 'کپی کردن آدرس صفحه' }}</span>
            </v-btn>
          </div>

          <div style="height: 70px; width: 100%;"></div>
        </div>
      </v-card>

      <div class="modern-footer-wrapper">
        <div class="footer-gradient-fade"></div>
        <div class="footer-content px-4 pb-2">
          <div class="d-flex justify-center align-center footer-brand"   @click="openLink">
            <img
              src="media/cr_logo.webp"
              alt="Terminal Ads"
              class="footer-logo ml-2"
              @error="$event.target.style.display='none'"
            />
            <span>قدرت گرفته از کیوآر لند</span>
          </div>
        </div>
      </div>
    </div>
   <transition name="fade">
      <div v-if="showPromo" class="preview-internal-overlay">      
      <PromoSheet 
        qrType="کیوآر روبیکا"
        @close="showPromo = false"
        @action="handleButtonAction"
        primary-color="#e52d8c"

      />
      </div>
      </transition>
  </mock-up-main>
</template>

<script>
import MockUpMain from "../../../businessPage/components/mockUp";
import ChannelQrModal from "../../eitaa/component/ChannelQrModal.vue";
import PromoSheet from "../../eitaa/component/PromoSheet.vue";

export default {
  name: "robikaMobilePreview",
  components: {
    MockUpMain,
    ChannelQrModal,
    PromoSheet
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    qrSvgDataUrl: {
      type: String,
      default: "",
    },
    address:{
      String,
      default:'https://qrland.ir'
    }
  },
  data() {
    return {
      showPromo: false,

      showQrDialog: false,
      defaultrobikaLogo: "/media/socialnetwork/icon/robika.webp",
      isCopied: false,
      copyTimeout: null,
    };
  },
  computed: {
    cleanrobikaId() {
      if (!this.value?.robikaId) return "";
      return this.value.robikaId
        .trim()
        .replace(/^https?:\/\/(www\.)?web\.rubika\.ir\/(#\/)?(c\/)?/i, "")
        .replace(/^https?:\/\/(www\.)?rubika\.ir\//i, "")
        .replace(/^@/, "")
        .replace(/\/+$/, "")
        .trim();
    },

    robikaTargetUrl() {
      return this.cleanrobikaId
        ? `https://rubika.ir/${this.cleanrobikaId}`
        : "https://rubika.ir";
    },

    robikaWebTargetUrl() {
      return this.cleanrobikaId
        ? `https://rubika.ir/${this.cleanrobikaId}`
        : "https://web.rubika.ir";
    },

    bgImageUrl() {
      const photoObj = this.value?.photo;
      const rawImg =
        photoObj?.headBackground ||
        photoObj?.bgImage ||
        photoObj?.cover ||
        photoObj?.background ||
        this.value?.headBackground ||
        this.value?.bannerImage ||
        null;

      return this.resolveFullImageUrl(rawImg);
    },

    profileAvatar() {
      const photoObj = this.value?.photo;
      const rawAvatar =
        photoObj?.profile ||
        photoObj?.logo ||
        photoObj?.avatar ||
        this.value?.avatar ||
        null;

      return this.resolveFullImageUrl(rawAvatar) || this.defaultrobikaLogo;
    },

    textColor() {
      return this.value?.pallete?.textColor || "#ffffff";
    },

    headerStyle() {
      const headBg =
        this.value?.pallete?.headColor ||
        "linear-gradient(135deg, #7c25c7 0%, #e52d8c 100%)";

      return {
        background: headBg,
      };
    },

    appButtonStyle() {
      const btnBg =
        this.value?.pallete?.btnColor ||
        this.value?.pallete?.headColor ||
        "linear-gradient(135deg, #7c25c7 0%, #e52d8c 100%)";

      return {
        background: `${btnBg} !important`,
        borderColor: this.value?.pallete?.borderColor || "rgba(255, 255, 255, 0.25)",
      };
    },

    containerStyle() {
      const bodyColor =
        this.value?.pallete?.bodyColor ||
        "linear-gradient(180deg, #1c0a35 0%, #0f051d 100%)";

      return {
        background: bodyColor,
        color: this.textColor,
      };
    },
  },
  beforeDestroy() {
    if (this.copyTimeout) clearTimeout(this.copyTimeout);
  },
  methods: {
    openLink(){
      window.open('https://qrland.ir', '_blank');
     },
     handleButtonAction(actionType) {
      window.open('https://core.terminalads.com/#/login', '_blank');
    },
    resolveFullImageUrl(img) {
      if (!img) return null;

      if (Array.isArray(img)) {
        img = img[0];
        if (!img) return null;
      }

      if (typeof img === "object") {
        if (img.url && typeof img.url === "string") {
          img = img.url;
        } else if (img[""] && typeof img[""] === "string") {
          img = img[""];
        } else {
          const values = Object.values(img).filter(
            (v) => typeof v === "string" && v.trim().length > 0
          );
          if (values.length > 0) {
            img = values[0];
          } else {
            return null;
          }
        }
      }

      if (typeof img === "string") {
        img = img.trim();
        if (!img) return null;

        if (
          img.startsWith("http://") ||
          img.startsWith("https://") ||
          img.startsWith("data:") ||
          img.startsWith("//") ||
          img.startsWith("blob:")
        ) {
          return img;
        }

        if (img.startsWith("upload/") || img.includes("cdn.terminalads.com")) {
          return `https://cdn.terminalads.com/${img.replace(/^\//, "")}`;
        }

        const baseUrl = this.$coreApi3 || "https://api.terminalads.com";
        const cleanPath = img.startsWith("/") ? img : `/storage/${img}`;
        return `${baseUrl.replace(/\/$/, "")}${cleanPath}`;
      }

      return null;
    },

    copyrobikaLink() {
      const link = this.robikaTargetUrl;
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(link)
          .then(() => this.triggerCopySuccess())
          .catch(() => this.fallbackCopy(link));
      } else {
        this.fallbackCopy(link);
      }
    },

    fallbackCopy(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand("copy");
        this.triggerCopySuccess();
      } catch (err) {
        this.$toast?.error("خطا در کپی آدرس");
      }
      document.body.removeChild(textArea);
    },

    triggerCopySuccess() {
      this.isCopied = true;
      this.$toast?.success("لینک روبیکا با موفقیت کپی شد.");
      if (this.copyTimeout) clearTimeout(this.copyTimeout);
      this.copyTimeout = setTimeout(() => {
        this.isCopied = false;
      }, 2500);
    },
  },
};
</script>

<style scoped>
.robika-device-container {
  position: relative;
  height: 100%;
  width: 100%;
  border-radius: 28px;
  overflow: hidden;
}

.robika-preview-wrapper {
  position: relative;
  height: 100%;
  min-height: 580px;
  z-index: 1;
  transition: all 0.35s ease;
  scrollbar-width: none;
}
.robika-preview-wrapper::-webkit-scrollbar {
  display: none;
}

.robika-header-section {
  position: relative;
  width: 100%;
  height: 125px;
  border-bottom-left-radius: 40px;
  border-bottom-right-radius: 40px;
  overflow: hidden;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.2);
  z-index: 2;
  transition: background 0.3s ease;
}

/* استایل دکمه شناور QR روبیکا */
.qr-floating-btn {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 6;
  background: rgba(255, 255, 255, 0.88) !important;
  color: #e52d8c !important;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  transition: transform 0.2s ease, background 0.2s ease;
}
.qr-floating-btn:hover {
  transform: scale(1.08);
  background: #ffffff !important;
}

.header-bg-texture {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  opacity: 0.45;
}

.header-gradient-layer {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.12) 0%, rgba(0, 0, 0, 0.25) 100%);
}

.content-container {
  position: relative;
  z-index: 2;
  margin-top: -46px;
}

.avatar-wrapper {
  position: relative;
  display: inline-block;
}
.robika-avatar {
  border: 4px solid rgba(255, 255, 255, 0.9);
  background: #ffffff;
}
.robika-badge {
  position: absolute;
  bottom: 4px;
  right: 4px;
  background: #ffffff;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}
.badge-icon-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 50%;
}

.title-glow {
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
}
.robika-subtitle {
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
}
.robika-id-pill {
  background: rgba(255, 255, 255, 0.18);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.28);
  color: #ffffff;
  border-radius: 30px;
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  direction: ltr;
}
.id-text {
  letter-spacing: 0.5px;
}
.robika-bio {
  line-height: 1.8;
  font-weight: 400;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.robika-app-btn {
  background: linear-gradient(135deg, #7c25c7 0%, #e52d8c 100%) !important;
  color: #ffffff !important;
  font-weight: bold;
  font-size: 14.5px !important;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.25s ease;
}
.robika-app-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(229, 45, 140, 0.45) !important;
}
.arrow-icon {
  opacity: 0.75;
}

.robika-web-btn {
  background: rgba(255, 255, 255, 0.15) !important;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.28) !important;
  color: #ffffff !important;
  font-weight: 500;
  font-size: 14px !important;
  transition: all 0.25s ease;
}
.robika-web-btn:hover {
  background: rgba(255, 255, 255, 0.25) !important;
}

.copy-btn {
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 12px;
}
.copy-btn.copied-active {
  color: #ff77c6 !important;
  font-weight: bold;
}

.modern-footer-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  pointer-events: none;
}
.footer-gradient-fade {
  height: 35px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.35), transparent);
}
.footer-content {
  background: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(8px);
  pointer-events: auto;
}
.footer-brand {
  font-size: 11px;
  opacity: 0.85;
  color: #ffffff;
}
.footer-logo {
  height: 18px;
  object-fit: contain;
}
.bio-glass-card {
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 18px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}
.robika-bio {
  line-height: 1.85;
  opacity: 0.95;
  font-size: 13px !important;
}

.robika-app-btn {
  position: relative;
  overflow: hidden;
  color: #ffffff !important;
  font-weight: 800;
  font-size: 14.5px !important;
  height: 52px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.robika-app-btn:hover {
  transform: translateY(-2.5px);
  box-shadow: 0 10px 25px rgba(229, 45, 140, 0.5) !important;
}
.btn-icon-wrapper {
  background: rgba(255, 255, 255, 0.22);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.arrow-anim {
  transition: transform 0.25s ease;
}
.robika-app-btn:hover .arrow-anim {
  transform: translateX(-4px);
}
.shimmer-effect::after {
  content: '';
  position: absolute;
  top: -50%;
  left: -60%;
  width: 40%;
  height: 200%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.35) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  transform: rotate(25deg);
  animation: shimmerSweep 3.5s infinite;
}
@keyframes shimmerSweep {
  0% { left: -60%; }
  35% { left: 140%; }
  100% { left: 140%; }
}
.relative-position {
  position: relative;
  overflow: hidden;
}

.preview-internal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6); 
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; 
  padding: 16px; 
}

.promo-inside-preview {
  width: 100% !important;
  max-width: 400px;
  max-height: 90%; 
  overflow-y: auto; 
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
